import { motion } from 'framer-motion'
import { FaLinkedin } from 'react-icons/fa' // ✅ Add this
import TiltedCard from '../UI/TiltedCard'
import BlueHeaderSection from '../BlueHeader'

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: (i = 1) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.3,
      duration: 0.7,
      ease: 'easeOut',
    },
  }),
}

const teamData = [
  {
    name: 'ANKIT GODHA',
    role: 'CEO\u00A0/\u00A0Co-Founder',
    imageSrc: '/Images/Ankit.png',
    bio: 'CEO / Co-Founder',
    linkedin: 'https://www.linkedin.com/in/ankitgodha/',
  },
  {
    name: 'AMIT MAHESHWARI',
    role: 'Director of Delivery',
    imageSrc: '/Images/Amit.png',
    bio: 'Director of Delivery',
    linkedin: 'https://www.linkedin.com/in/amit-m-46a99127b/',
  }
]

const TeamSection = () => {
  const bg = 'bg-white'
  const text = 'text-[#1b2f5a]'

  return (
    <>
      <BlueHeaderSection heading="Meet Our Team" url="Meet Our Team" />
      <section
        className={`px-4 sm:px-8 md:px-16 rounded-b-[40px] ${bg} ${text} pb-5  py-16`}
        style={{
          backgroundColor: '#ffffff',
          backgroundSize: 'cover',
          backgroundAttachment: 'fixed',
          backgroundPosition: 'center',
        }}
      >
        <motion.h2
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeUp}
          className="text-center text-4xl sm:text-5xl font-bold mb-10"
        >
          Meet <span>Our</span> Leaders
          <div className="w-24 h-1 bg-[#f7941d] mx-auto mt-4"></div>
        </motion.h2>

        <motion.h2
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeUp}
          className="text-center text-3xl font-bold mb-6 text-black"
        >
          Inside <span className="">BytesFarms</span> Talented Developers, Designers & Tech Leaders
        </motion.h2>

        <motion.p
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeUp}
          className="text-center text-lg max-w-3xl mx-auto text-black opacity-80 mb-16"
        >
          Discover the dynamic team at <span className="">BytesFarms</span> — a
          powerhouse of innovation, creativity, and hands-on expertise. From
          strategic thinkers to technical specialists, every individual brings a
          distinctive strength to our collaborative culture. We celebrate
          diverse perspectives working in sync toward one mission: delivering
          digital excellence that drives real results.
        </motion.p>

        <div className="flex flex-wrap justify-center gap-10">
          {teamData.map((member, i) => (
            <motion.div
              key={i}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              custom={i}
              variants={fadeUp}
            >
              <TiltedCard
                imageSrc={member.imageSrc}
                altText={`${member.name} – ${member.role}`}
              captionText={`${member.name} – ${member.role}`}
                 containerHeight="340px"
                imageHeight="340px"
                imageWidth="260px"
                scaleOnHover={1.15}
                rotateAmplitude={14}
                displayOverlayContent={true}
                overlayContent={
                  <div className="p-4 text-white text-sm w-[260px]">
                    <h3 className="font-bold text-lg mb-1 text-[#f7941d]">
                      {member.name}
                    </h3>
                    <p className="mb-2">{member.bio}</p>
                    <a
                      href={member.linkedin}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-2 text-white hover:text-[#f7941d] transition"
                    >
                      <FaLinkedin className="text-2xl" />
                    </a>
                  </div>
                }
              />
            </motion.div>
          ))}
        </div>
      </section>
    </>
  )
}

export default TeamSection